<ng-container *ngIf="miscellaneousFieldsConfig.mothersMaidenName ||
                                        miscellaneousFieldsConfig.last4ssn ||
                                        miscellaneousFieldsConfig.homePhone ||
                                        miscellaneousFieldsConfig.workPhone ||
                                        miscellaneousFieldsConfig.ssn">

    <div class="m-form__group" *ngIf="applicant">
        <h2 class="section-title" [attr.data-test-id]="testId + '.title'">Additional Information</h2>
        <form #f="ngForm" [attr.data-test-id]="testId + '.form'">
            <div class="row">
                <ng-container *ngIf="miscellaneousFieldsConfig.mothersMaidenName">
                    <div [class]="cssWidthClass">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.mothers-maiden-name-label'">Mother's Maiden Name</mat-label>
                            <input matInput type="text" name="mothersMaidenName"
                                   autocomplete="off" alphabetOnly
                                   [(ngModel)]="applicant.mothersMaidenName" #mothersMaidenName="ngModel"
                                   required
                                   [attr.data-test-id]="testId + '.mothers-maiden-name-input'">
                            <mat-error [attr.data-test-id]="testId + '.mothers-maiden-name.required-error'">Please enter your mother's maiden name.</mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>

                <ng-container *ngIf="miscellaneousFieldsConfig.ssn">
                    <div [class]="cssWidthClass">
                        <creditsnap-ssn #ssn [(ngModel)]="applicant.ssn" name="ssn"
                                        [data-test-id]="testId + '.ssn'"></creditsnap-ssn>
                    </div>
                </ng-container>

                <ng-container *ngIf="!miscellaneousFieldsConfig.ssn && miscellaneousFieldsConfig.last4ssn">
                    <div [class]="cssWidthClass">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-label [attr.data-test-id]="testId + '.last4ssn-label'">Last 4-digits of SSN</mat-label>
                            <input matInput type="tel" name="last4SSN" numbersOnly
                                   #last4ssn="ngModel" [(ngModel)]="applicant.ssn"
                                   maxlength="4" minlength="4" required
                                   [data-test-id]="testId + '.last4ssn-input'">
                            <mat-error *ngIf="last4ssn.hasError('required')" [attr.data-test-id]="testId + '.last4ssn.required-error'">
                                Please enter the last four digits of your Social Security number.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>

                <ng-container *ngIf="['optional','required'].indexOf(miscellaneousFieldsConfig.homePhone) >= 0">
                    <div [class]="cssWidthClass">
                        <creditsnap-phone-number [(ngModel)]="applicant.homePhone" [label]="'Home Phone Number'"
                                                #homePhone="ngModel" name="homePhone"
                                                [options]="homePhoneOptions"
                                                [data-test-id]="testId + '.home-phone'"></creditsnap-phone-number>
                    </div>
                </ng-container>

                <ng-container *ngIf="miscellaneousFieldsConfig.workPhone">
                    <div [class]="cssWidthClass">
                        <creditsnap-phone-number [(ngModel)]="applicant.workPhone" [label]="'Work Phone Number'"
                                                 #workPhone="ngModel" name="workPhone"
                                                 [data-test-id]="testId + '.work-phone'"></creditsnap-phone-number>
                    </div>
                </ng-container>

            </div>
        </form>
    </div>
</ng-container>
